import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { PosService } from '../../services/pos.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrls: ['./token.component.css']
})
export class PosTokenComponent implements OnInit {
  @ViewChild('closeNewTokenButton', { static: false }) closeNewTokenButton: ElementRef;

  constructor(private sharedService: SharedService,
    private posService: PosService) { }

  posTokens: [] = [];
  posClientKey: string = "";
  posClient: string = "";
  newClient: string = "";
  showErrorMessage: boolean = false;
  errorMessage: string = "";
  showLoadingMessage: boolean = false;

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadPosTokens();
    this.clearFields();
  }

  loadPosTokens() {
    this.showLoadingMessage = true;
    this.posService.getTokens().subscribe(data => {
      this.posTokens = data;
      this.showLoadingMessage = false;
    },
      err => this.showLoadingMessage = false);
  }

  openResetTokenComputerKeyConfirmation(posClient, posClientKey) {
    this.posClient = posClient;
    this.posClientKey = posClientKey;
  }

  openDeleteTokenConfirmation(posClient: string, posClientKey: string) {
    this.posClient = posClient;
    this.posClientKey = posClientKey;
    Swal.fire({
      icon: 'question',
      title: 'Delete Token',
      html: `<p>Do you really want to delete the token for <strong>${posClient}</strong>?</p><p>This action cannot be undone.</p>`,
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      this.posService.deleteToken(posClientKey).subscribe(
        resultVo => {
          if (resultVo.success) {
            this.sharedService.showTempSuccessMessage();
            this.loadPosTokens();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Delete Token',
              text: resultVo.message || 'Failed to delete token.',
            });
          }
        },
        error => {
          Swal.fire({
            icon: 'error',
            title: 'Delete Token',
            text: 'An error occurred while deleting the token.',
          });
        }
      );
    });
  }

  resetTokenComputerKey(posClientKey) {
    this.posService.resetTokenComputerKey(this.posClientKey).subscribe(resultVo => {
      if (resultVo.success)
        this.sharedService.showTempSuccessMessage();
    });
  }

  onCreateToken() {
    if (this.newClient != "") {
      this.posService.createToken(this.newClient).subscribe(resultVo => {
        if (resultVo.success) {
          this.closeNewTokenButton.nativeElement.click();
          this.sharedService.showTempSuccessMessage();
          this.loadPosTokens();
          this.clearFields();
        } else {
          this.loadErrorMessage(resultVo.message);
        }
      });
    } else {
      this.loadErrorMessage("Client Name field is empty");
    }
  }

  loadErrorMessage(message: string) {
    this.showErrorMessage = true;
    this.errorMessage = message;
  }

  clearFields() {
    this.showErrorMessage = false;
    this.newClient = "";
  }
}
